import React from 'react';
import { Component } from 'react';
import type { MediaClientConfig } from '@atlaskit/media-core';
import type { MediaItemType } from '@atlaskit/media-client';
import { MediaFileListViewer } from './media-file-list-viewer';
import type { MediaViewerConstructor, MediaViewerConfig } from './mediaviewer';

export interface MediaViewerItem {
	id: string;
	occurrenceKey?: string;
	type: MediaItemType;
}

export interface MediaViewerDataSource {
	list?: Array<MediaViewerItem>;
	collectionName?: string;
}

export interface MediaViewerProps {
	readonly mediaClientConfig: MediaClientConfig;

	readonly selectedItem: MediaViewerItem;
	readonly dataSource: MediaViewerDataSource;

	readonly collectionName: string;
	readonly pageSize?: number;

	readonly MediaViewer: MediaViewerConstructor;
	readonly mediaViewerConfiguration?: MediaViewerConfig;
	readonly basePath: string;
	readonly onClose?: () => void;
}

export interface MediaViewerState {}

// MS-751 Clean up the whole media viewer legacy folder (and all references to it) once MVNG rollout is completed
export class MediaViewer extends Component<MediaViewerProps, MediaViewerState> {
	render(): JSX.Element {
		const { onClose, mediaClientConfig, selectedItem, collectionName, dataSource } = this.props;

		if (dataSource.list) {
			return (
				<MediaFileListViewer
					mediaClientConfig={mediaClientConfig}
					selectedItem={selectedItem}
					list={dataSource.list}
					collectionName={collectionName}
					MediaViewer={this.props.MediaViewer}
					mediaViewerConfiguration={this.props.mediaViewerConfiguration}
					basePath={this.props.basePath}
					onClose={onClose}
				/>
			);
		} else {
			throw new Error(
				'MediaViewer does not support the provided datasource (MediaViewerDataSource)',
			);
		}
	}
}
